import http from '../../../utils/fetch';
import updownfile from '../../../utils/updownfile';
export default {

    baseUrl:"/api/swyl/v1/cost/bscCostData",

    selectById(q){
        return http({
            url: this.baseUrl + '/selectById',
            method: 'post',
            params: q
        });
    },

}